<div  [className]="className" [style]="styleName">

      <label for="{{ctrId}}" 
             [className]="labelClass" 
             [style]="labelStyle" 
             [translateParams]="labelParam" translate>
             <span [innerHTML]="label|translate:labelParam"></span>
             <ng-content></ng-content>
      </label>

      <div *ngIf="hintText" [className]="hintClass"  [innerHTML]="hintText|translate:hintParam"
                                [style]="hintlStyle"></div>


      <select id="{{ctrId}}"  
             [className]="inputClass" 
             [style]="inputStyle"
             [attr.disabled]="disable||!itemList?true:null"
             [ngModel]="inputX"
             (ngModelChange)="inputModelChange($event)"
             (focus)="onFocus()" 
             (blur)="onBlur()"
             (change)="valueChanged()"
             attr.aria-describedby="error_{{ctrId}}">

             <option *ngIf="placeholder"   value=''>{{placeholder}}</option>
             <option *ngIf="!placeholder"  value=''>{{'shared.select.one'|translate}}</option>

             <option [className]="textClass" [style]="textStyle"
                    *ngFor="let item of itemList | keyvalue : asIsOrder"  
                     value="{{item.key}}" [attr.disabled]="item.key==-2?true:null" [innerHTML]="item.value"></option>                    

      </select>
    
      <div [hidden]="!error" 
           [className]="errorClass"
           [style]="errorStyle" id="error_{{ctrId}}">
               <b>{{!error? '':'error.prefix'| translate}}</b>
               <span [innerHTML]="error|translate:errorParam" ></span>
      </div>
</div>


<!--  class="outer-box" <span class="vis-icon" style="color:#093b69; right: 0.2em;"  (click)="onClear()" [hidden]="this.input==0">✖</span> -->